import {TABLE_SIZE_L, TABLE_SIZE_M} from "../../../offerte/OfferteHelper";

export const headCells = [
    {
        id: "nome",
        text: "Nome",
        width: TABLE_SIZE_M
    },
    {
        id: "costo-attivazione",
        text: "Costo Attivazione",
        width: TABLE_SIZE_M
    },
    {
        id: "canone-unitario",
        text: "Canone Unitario",
        width: TABLE_SIZE_L
    }
]